export interface IProductForm {
  productName: string;
  brandId: string;
  productPrice: number;
  categoryId: string;
  subCategoryId: string;
  productPrimaryImageUrl: string;
  multipleProductImageUrl: string[];
  productSpecification: string;
  installationFee: number;
  buyerNote: string;
  weight: number;
  slug: string;
  shortDescription: string;
  productCode: string;
  longDescription: string;
  monthlyFinancing: number;
  rating: number;
  productQuantity: number;
  // productDescription: string;
}

export class ProductForm {
  productName: string = "";
  brandId: string = "";
  productPrice: number = 0;
  categoryId: string = "";
  subCategoryId: string = "";
  productPrimaryImageUrl: string = "";
  multipleProductImageUrl: string[] = [];
  productSpecification: string = "";
  installationFee: number = 0;
  buyerNote: string = "";
  weight: number = 0;
  slug: string = "";
  shortDescription: string = "";
  productCode: string = "";
  longDescription: string = "";
  monthlyFinancing: number = 0;
  rating: number = 0;
  productQuantity: number = 0;
  // productDescription: string = "";
}

export interface IProductSheet {
  Name: string;
  Brand: string;
  Price: number;
  Category: string;
  Description: string;
  Quantity: number;
  Note: string;
  Weight: number;
}

export interface IFileDetails {
  name: string;
  size: number;
  type: string;
  webkitRelativePath: string;
}
export class FileDetails {
  name: string = "";
  size: number = 0;
  type: string = "";
  webkitRelativePath: string = "";
}

export interface IProductCategory {
  categoryId: string;
  category: string;
  banner: string | null;
  commision: number;
  isTopCategory: boolean;
  isRemoved: boolean;
}

export class ProductCategory {
  categoryName: string = "";
  banner: string = "";
  commision: string = "";
}

export interface ICategoryData {
  categoryId: string;
  category: string;
  banner: string | null;
  commision: number;
  isTopCategory: boolean;
  isRemoved: boolean;
}

export class ProductCategoryResponse {
  data: ICategoryData[] = [];
  responseCode: string = "";
  responseMessage: string = "";
  isSuccessful: boolean = false;
}

export interface IBrandData {
  brandName: string;
  image: string;
  brandId: string;
}

export interface IProductBrandResponse {
  data: IBrandData[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export interface IOrderItem {
  orderItemId: string;
  orderId: string;
  orderNumber: string;
  status: string;
  paymentStatus: string;
  productId: string;
  productQuatity: number;
  unitPrice: number;
  totalPrice: number;
  vendorId: string;
  vendorName: string;
  productName: string;
  customerName: string;
  dateCreated: string;
  product: IOrderProduct;
  vendor: IOrderVendor;
  paymentMode:string;
  customerAddress:string;
  customerPhoneNumber:string;
}
export interface IOrderProduct {
  productId: string;
  vendorId: string;
  categoryId: string;
  subCategoryId: string;
  productName: string;
  brandId: string;
  productCurrentPrice: number;
  productPreviousPrice: number;
  productPrimaryImageUrl: string;
  productSpecification: string;
  buyerNote: string;
  status: string;
  productQuantity: number;
  productCode: string;
  shortDescription: string;
  longDescription: string;
  weight: number;
  images: string;
  monthlyFinancing: number;
  rating: number;
  slug: string;
  installationFee: number;
  authoredAdmin: string;
  isEnable: boolean;
  isTopDeal: boolean;
  applyVat: boolean;
  applyVatPrice: number;
  isDeliveryCarryOut: boolean;
  isBundle: boolean;
  isRemoved: boolean;
  isWarranty: string;
  reason: string;
  productImages: string;
  createdAt: string;
  updatedAt: string;
}
export interface IOrderVendor {
  id: string;
  vendorId: string;
  storeUserId: string;
  firstName: string;
  lastName: string;
  email: string;
  gender: string;
  address: string;
  phoneNumber: string;
  password: string;
  isEmailVerified: boolean;
  sellingPermission: boolean;
  status: string;
  vendorRoleId: string;
  roleName: string;
  isProfileCompleted: boolean;
  isActive: boolean;
  isSuspended: boolean;
  rating: string;
  storeName: string;
  slug: string;
  storeUrl: string;
  storeAddress: string;
  storeLGA: string;
  storeState: string;
  storeHeader: string;
  storeLogo: string;
  bankAccountName: string;
  bankAccountNumber: string;
  information: string;
  lastLogin: string;
  accessToken: string;
  refreshToken: string;
  tokenGenerationTime: string;
  reasonForStoreStatus: string;
  createdAt: string;
  updatedAt: string;
}
export interface IOrderItemUpdate {
  orderId: string;
  status: string;
}
export class OrderProduct {
  productId: string = "";
  vendorId: string = "";
  categoryId: string = "";
  subCategoryId: string = "";
  productName: string = "";
  brandId: string = "";
  productCurrentPrice: number = 0;
  productPreviousPrice: number = 0;
  productPrimaryImageUrl: string = "";
  productSpecification: string = "";
  buyerNote: string = "";
  status: string = "";
  productQuantity: number = 0;
  productCode: string = "";
  shortDescription: string = "";
  longDescription: string = "";
  weight: number = 0;
  images: string = '';
  monthlyFinancing: number = 0;
  rating: number = 0;
  slug: string = "";
  installationFee: number = 0;
  authoredAdmin: string = '';
  isEnable: boolean = false;
  isTopDeal: boolean = false;
  applyVat: boolean = false;
  applyVatPrice: number = 0;
  isDeliveryCarryOut: boolean = false;
  isBundle: boolean = false;
  isRemoved: boolean = false;
  isWarranty: string = '';
  reason: string = "";
  productImages: string = '';
  createdAt: string = "";
  updatedAt: string = '';
}
export class OrderVendor {
  id: string = "";
  vendorId: string = "";
  storeUserId: string = '';
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  gender: string = '';
  address: string = "";
  phoneNumber: string = "";
  password: string = "";
  isEmailVerified: boolean = false;
  sellingPermission: boolean = false;
  status: string = "";
  vendorRoleId: string = '';
  roleName: string = "";
  isProfileCompleted: boolean = false;
  isActive: boolean = false;
  isSuspended: boolean = false;
  rating: string = '';
  storeName: string = "";
  slug: string = '';
  storeUrl: string = '';
  storeAddress: string = "";
  storeLGA: string = "";
  storeState: string = "";
  storeHeader: string = "";
  storeLogo: string = "";
  bankAccountName: string = '';
  bankAccountNumber: string = '';
  information: string = "";
  lastLogin: string = "";
  accessToken: string = "";
  refreshToken: string = "";
  tokenGenerationTime: string = "";
  reasonForStoreStatus: string = "";
  createdAt: string = "";
  updatedAt: string = "";
}
export class OrderItem {
  orderItemId: string = "";
  orderId: string = "";
  orderNumber: string = "";
  status: string = "";
  paymentStatus: string = "";
  productId: string = "";
  productQuatity: number = 0;
  unitPrice: number = 0;
  totalPrice: number = 0;
  vendorId: string = "";
  vendorName: string = "";
  productName: string = "";
  customerName: string = "";
  dateCreated: string = "";
  product: OrderProduct = new OrderProduct();
  vendor: OrderVendor = new OrderVendor();
  paymentMode:string = "";
  customerAddress:string = "";
  customerPhoneNumber:string = "";
}
export interface IOrderResponse {
  data: IOrderItem[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export enum PaymentMode {
  payLater = "Pay Later",
  payStack = "Pay Now",
  altPay = "AltPay",
}